module.exports = __webpack_public_path__ + "static/media/reservationGreen.91e4c3fb.svg";